<template>
  <div>
    <PageHeader :title="$t('Navigation.Training')" />

    <div v-if="isLoadingStoresTab" class="flex justify-center py-16">
      <Loading />
    </div>
    <template v-else>
      <Tabs v-if="showStoresTab" :tabs="tabs" @tab-selected="selectTab" />

      <StoresTrainingCompletion v-if="isStoresTabActive" />
      <TrainingResources
        v-else
        :show-sales-guide="!hasExternalPosOnlySubscription"
        :show-seats-furniture-guides="hasSeatsOrFurniture"
        :show-bv-warranty-extension-guides="hasBvWarrantyExtension"
        :training-modules="trainingModules"
        @open-module="openModule"
      />
    </template>
  </div>
</template>

<script>
import { Loading, TrainingResources, PageHeader, Tabs } from "@estaly/ui";
import { mapActions, mapGetters, mapState } from "vuex";
import { useI18n } from "vue-i18n";
import StoresTrainingCompletion from "@/components/training-module/stores-completion/StoresTrainingCompletion.vue";

const STORES_TAB = "stores";

export default {
  name: "Training",
  components: {
    Loading,
    TrainingResources,
    PageHeader,
    Tabs,
    StoresTrainingCompletion,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      isLoadingModules: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["accessibleStoreIds"]),
    ...mapGetters("businessVerticals", [
      "hasExternalPosOnlySubscription",
      "hasSeatsOrFurniture",
      "hasBvWarrantyExtension",
    ]),
    ...mapState("trainingModules", ["trainingModules"]),
    ...mapGetters("trainingModules", { showStoresTab: "canFollowStoresCompletion" }),
    // A link to the stores tab waits for the modules instead of flashing the guides (unless already known)
    isLoadingStoresTab() {
      return this.isLoadingModules && this.$route.query.tab === STORES_TAB && !this.showStoresTab;
    },
    isStoresTabActive() {
      return this.showStoresTab && this.$route.query.tab === STORES_TAB;
    },
    tabs() {
      return [
        { name: "guides", displayName: this.t("guides_tab"), current: !this.isStoresTabActive },
        { name: STORES_TAB, displayName: this.t("stores_tab"), current: this.isStoresTabActive },
      ];
    },
  },
  async created() {
    if (!this.accessibleStoreIds.length) return;

    this.fetchIndex({ storeId: [this.accessibleStoreIds[0]], enabled: true });
    this.isLoadingModules = true;
    try {
      await this.fetchTrainingModules(this.accessibleStoreIds);
    } finally {
      this.isLoadingModules = false;
    }
  },
  methods: {
    ...mapActions("businessVerticals", ["fetchIndex"]),
    ...mapActions("trainingModules", { fetchTrainingModules: "fetchIndex" }),
    openModule(trainingModule) {
      this.$router.push(`/admin/training/module/${trainingModule.id}`);
    },
    selectTab(tab) {
      const tabQuery = tab.name === STORES_TAB ? STORES_TAB : undefined;
      this.$router.replace({ query: { ...this.$route.query, tab: tabQuery } });
    },
  },
};
</script>

<i18n src="./Training.i18n.json"></i18n>
